import { useEffect } from "react";
import { useAuth } from "../auth/useAuth";
import { useNotificationOwnerScope } from "./useNotificationOwnerScope";
import { useNotificationsQuery } from "./useNotificationsQuery";
import { clearAppBadge, syncAppBadge } from "../utils/appBadge";

export const useAppBadge = () => {
  const { isAuthenticated } = useAuth();
  const ownerScope = useNotificationOwnerScope();
  const { data, refetch } = useNotificationsQuery({
    read: "unread",
    limit: 1,
    ...ownerScope,
  });

  const unreadCount = isAuthenticated ? (data?.stats?.unread ?? 0) : 0;

  useEffect(() => {
    if (!isAuthenticated) {
      void clearAppBadge();
      return;
    }

    void syncAppBadge(unreadCount);
  }, [isAuthenticated, unreadCount]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        void refetch();
      }
    };

    const handleFocus = () => {
      void refetch();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [isAuthenticated, refetch]);
};
